class LanguageSelectorPopup extends HTMLElement {
  constructor() {
    super();
    this.modal = this.querySelector('[data-language-popup-modal]');
    this.trigger = this.querySelector('[data-language-popup-trigger]');
    this.closeBtn = this.querySelector('[data-language-popup-close]');
    this.overlay = this.querySelector('[data-language-popup-overlay]');
    this.options = this.querySelectorAll('[data-language-popup-option]');
    this.form = this.closest('form');
    this.input = this.form?.querySelector('[data-disclosure-input]');
    this.countryInput = this.form?.querySelector('[data-disclosure-country-input]');
    this.isOpen = false;
  }

  connectedCallback() {
    if (!this.modal || !this.trigger) return;

    this.boundHandleTriggerClick = this.#handleTriggerClick.bind(this);
    this.boundHandleClose = this.#handleClose.bind(this);
    this.boundHandleOptionClick = this.#handleOptionClick.bind(this);
    this.boundHandleKeydown = this.#handleKeydown.bind(this);

    this.trigger.addEventListener('click', this.boundHandleTriggerClick);
    this.closeBtn?.addEventListener('click', this.boundHandleClose);
    this.overlay?.addEventListener('click', this.boundHandleClose);
    
    this.options.forEach(option => {
      option.addEventListener('click', this.boundHandleOptionClick);
    });

    document.addEventListener('keydown', this.boundHandleKeydown);
  }

  disconnectedCallback() {
    this.trigger?.removeEventListener('click', this.boundHandleTriggerClick);
    this.closeBtn?.removeEventListener('click', this.boundHandleClose);
    this.overlay?.removeEventListener('click', this.boundHandleClose);
    this.options.forEach(option => {
      option.removeEventListener('click', this.boundHandleOptionClick);
    });
    document.removeEventListener('keydown', this.boundHandleKeydown);
  }

  #handleTriggerClick(e) {
    e.preventDefault();
    this.#open();
  }

  #handleClose(e) {
    if (e) {
      e.preventDefault();
    }
    this.#close();
  }

  #handleOptionClick(e) {
    e.preventDefault();
    const option = e.currentTarget;
    const localeCode = option.dataset.value;
    const countryCode = option.dataset.countryValue;

    if (!localeCode || !this.input) return;

    const urls = window.theme && window.theme.urls;
    if (
      urls &&
      typeof urls.isAdvisorHubMicrosite === 'function' &&
      urls.isAdvisorHubMicrosite() &&
      typeof urls.redirectToLocale === 'function'
    ) {
      urls.redirectToLocale(localeCode);
      return;
    }

    this.input.value = localeCode;

    if (countryCode && this.countryInput) {
      this.countryInput.value = countryCode;
    }

    this.form.submit();
  }

  #handleKeydown(e) {
    if (e.key === 'Escape' && this.isOpen) {
      this.#close();
    }
  }

  #open() {
    if (!this.modal) return;
    this.modal.classList.add('language-selector-popup__modal--open');
    this.trigger.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    this.isOpen = true;
    
    requestAnimationFrame(() => {
      this.closeBtn?.focus();
    });
  }

  #close() {
    if (!this.modal) return;
    this.modal.classList.remove('language-selector-popup__modal--open');
    this.trigger.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    this.isOpen = false;
    this.trigger.focus();
  }
}

customElements.define('language-selector-popup', LanguageSelectorPopup);
